import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { LeadsPoolConfigurationRoutes } from '../../../routes/HomeRoutes/LeadsPoolConfigurationRoutes';

export const LeadsPoolConfigurationLayout = () => <SwitchRoute routes={LeadsPoolConfigurationRoutes} />;
